import { render, staticRenderFns } from "./inquiry-list.vue?vue&type=template&id=66374342&"
import script from "./inquiry-list.vue?vue&type=script&lang=js&"
export * from "./inquiry-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports